import { createSlice } from '@reduxjs/toolkit'
import { StructuredDataStatus } from '@repo/shared/dtos/structured-data'

import { getBeneficiariesStructuredDataState } from '@/store/structured-data-state/thunks'

interface State {
  structuredDataState?: {
    currentStatusEpoch: number
    currentStatus: StructuredDataStatus
    totalBeneficiaries: number
    totalUpdatedBeneficiaries: number
  }
}

const initialState: State = {}

const slice = createSlice({
  name: 'structuredDataState',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBeneficiariesStructuredDataState.fulfilled, (state, { payload }) => {
      state.structuredDataState = payload
    })
  },
})

// export const {  } = slice.actions
export type { State as StructuredDataStateState }
export const structuredDataStateInitialState = initialState
export default slice.reducer
